import { NotificationEmailList } from './../activenotifications/qaticketnotification.model';
import { Component, OnInit } from "@angular/core";
import { MatDialog } from '@angular/material';
import { AddNotificationEmailComponent } from '../addnotificationemail/addnotificationemail.component';
import { NotificationsService } from './../activenotifications/notifications.service';

@Component({
  selector: "app-notificationtoemail",
  templateUrl: "./notificationtoemail.component.html",
  styleUrls: ["./notificationtoemail.component.scss"]
})

export class NotificationToEmailComponent implements OnInit {

  notificationEmailList: NotificationEmailList[] = [];

  constructor(
    public notificationService: NotificationsService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.notificationService.getEmailList().subscribe(res => {
      
      this.notificationEmailList = res;
    });
  }

  openSaveDialog() {
    let dialogRef = this.dialog.open(AddNotificationEmailComponent, {
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(result => {
      
      if (result === 'Cancel') {
        return;
      }
      else {
        
        this.notificationService.createEmail(result).then(res => {
          
          this.ngOnInit();
        });
      }

    });
  }

  deleteEmail(id: number){
    
    this.notificationService.deleteEmail(id).subscribe(res => {
      this.ngOnInit();
    });
  }
}
